import styled from 'styled-components';

const ShowsPageHolder = styled.div`
	position: relative;
	grid-area: content;
	overflow: auto;
	font-family: "Quicksand", sans-serif;
	width: 100%;
    margin: 0 auto;
	.list-container {
		width: calc(100% - 30px);
		padding: 20px 0;
		margin: 0 15px 0 15px;
		column-count: 3;
		max-width: 1920px;

		@media only screen and (max-width: 920px) {
			column-count: 2;
		}

		@media only screen and (max-width: 548px) {
			width: calc(100% - 30px);
			margin: 0 15px 0 15px;
			column-count: 1;
		}

		div {
			break-inside: avoid;
			border-top: 1px solid #d1cdc1;
			padding-top: 10px;
			margin-bottom: 80px;
			@media only screen and (max-width: 548px) {
				margin-bottom: 20px;
			}
		}
	}

	h2 {
		color: #383838;
		text-transform: uppercase;
    	font-size: 18px;
	}
	h3 {
		background-color: #726b55;
		color: white;
		width: 100%;
		left: 0;
		padding-left: 25px;
		min-height: 30px;
		line-height: 50px;
	    margin-top: 0px;
		margin-bottom: 0px;
		font-size: 24px;
		font-weight: 700;
		min-height: 50px;
	}
	a {
		color: #726b55;
		font-weight: 500;
		font-size: 17px;
		line-height: 1.5em;
		text-decoration: none;
	}

	.v-selectBtns-container {
		position: absolute;
		right: 25px;
		top: 7px;
		button {
			background: none;
			border: none;
			color: white;
			cursor: pointer;
			font-size: 14px;
			margin-top: 10px;
			margin-left: 10px;
			text-transform: uppercase;
			font-weight: 700;
			&:focus {
				border: none;
				outline:0;
			}
			svg {
				margin-right: 5px;
			}
		}
	}
`;

export default ShowsPageHolder;